import * as React from 'react';

import { BaseMoreFilter } from './';

import { FlightsSearchFormMoreFiltersOptionItem, FlightsSearchFormMoreFiltersOption } from 'types/search/wizard';

interface BaseMoreFiltersProps {
  searchOption: FlightsSearchFormMoreFiltersOption;
}
export const BaseMoreFilters = (props: BaseMoreFiltersProps) => {
  return (
    <>
      {props.searchOption.items.map((item: FlightsSearchFormMoreFiltersOptionItem, index: number) => (
        <BaseMoreFilter
          key={item.advancedFilterType}
          item={item}
          advancedFilterType={item.advancedFilterType}
          itemIndex={index}
          searchOption={props.searchOption}
        />
      ))}
    </>
  );
};
